
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import { Edit, ErrorOutline, Check, InfoOutlined as InfoIcon } from '@material-ui/icons';
import { Grid, Typography, Stepper, Step, StepLabel, StepConnector, LinearProgress, Button, Tooltip } from '@material-ui/core';
import { WithStyles, createStyles } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import _ from 'lodash';
import { MyPATCollapse, MyPATDialog, MyPATTextArea } from '../../common';
import { statusType } from '../types/ContentInSection'
import ContentData, { StepWiseSolution } from '../types/ContentData';
import contentService from '../services/contentService';
import ContentAuthorModal from './ContentAuthorModal';
import ContentPublishedModal from './ContentPublishedModal';
import ContentTagData from '../types/ContentTagData';
import ContentFormDataError from '../types/ContentFormDataError';
import ACLService from '../../acl/services/aclService';
import ContentReviwerModal from './ContentReviwerModal';
import { convertCamelCaseToText, calCulateProgressBar, isQuestionAddToQueueModeActive, checkIsCorrectAnswerChange, validateQuestionBenchmarks, scrollIntoView, isDifficultyAndSkillAddToQueueModeActive, isConceptAndChapterAddToQueueModeActive, checkIsDifficultyAndSkillChange, checkIsConceptAndChapterChange, convertSubjectWithId, getUserType, getPropertyValue, checkForTeacherUser, createDeepCopy } from '../../../utils';
import ContentSubtypeData from '../types/ContentSubtypeData';
import RepublishContentModal from './RepublishContentModal';
import CustomInfoIcon from '../../common/CustomInfoIcon';
import { ADD_TO_QUEUE_PROPERTIES, AUTHORING_CONTENT_TYPES, CONTENT_STATES, CONTENT_TYPE, QUESTION_TYPES, USER_TYPE } from '../../../constants/comman';
import AddToQueueQuestion from '../../common/AddToQueueQuestion';
import { Prompt } from 'react-router-dom';
import contentActions from '../actions/contentActions';
import { AllQuestionBenchmarks } from '../types/Benchmarks';
import { getTimeInSecs } from '../../../utils/getOffset.utils';
import { contentRequestAccordianActions } from '../../content-request/reducers/contentRequestAccordianState';
import classNames from 'classnames';
import { getGenericPrevExams } from '../helper/questionTab';
import { questionActions } from '../reducers/questionCreateReducer';
import { PreviousExamItem } from '../types/PreviousYearsQuestion';
import { showMsg as showAlert } from '../../course/actions/loaderAlert';
import SendNotification from '../containers/SendNotification';

import { CONTENT_SUBMIT_MODAL_BODY, FEEDBACK_VALIDATOR_ACTIONS, QUESTION_SUBMIT } from '../helper/contentValidation';
import contentRequestServices from '../../content-request/services/contentRequestServices';
import { PROPS_REMEDIAL_KEY } from './ContentCreate/RemedialComponent/RemedialQuestionConstants';
import PublishContentDirecltyModal from './PublishContentDirecltyModal';
const styles = (theme: Theme) =>
  createStyles({
    iOSSwitchBase: {
      '&$iOSChecked': {
        color: theme.palette.common.white,
        '& + $iOSBar': {
          backgroundColor: '#52d869',
        },
      },
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.sharp,
      }),
    },
    iOSChecked: {
      transform: 'translateX(18px)',
      '& + $iOSBar': {
        opacity: 1,
        border: 'none',
      },
    },
    iOSBar: {
      borderRadius: 13,
      width: 44,
      height: 22,
      marginTop: -11,
      marginLeft: -20,
      border: 'solid 1px',
      borderColor: '#999',
      backgroundColor: '#999',
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    iOSIcon: {
      width: 20,
      height: 20,
    },
    iOSIconChecked: {
      boxShadow: theme.shadows[1],
    },
    directPublish: {
      width: 792,
      padding: '15px 20px',
      borderRadius: 4,
      background: '#F4F4F4',
      display: 'flex',
      gap: '15px',
      textAlign: 'left',
      marginRight: 'auto',
      alignItems: 'center',
      justifyContent: 'center',
    },
    directPublishText: {
      fontSize: 20,
      color: '#666',
      lineHeight: '26px',
      fontWeight: 400,
    },
    active: {
      color: theme.palette.error.light,
    },
    stepDisabled: {
      padding: 0,
      "&>:first-child": {
        marginBottom: 0,
      },
    },
    successIcon: {
      backgroundColor: "#379D0B",
    },
    primaryColor: {
      backgroundColor: theme.palette.primary.main,
    },
    warningIcon: {
      color: "#FF4A4A !important",
      padding: "0 !important",
      transform: "scale(1.3)",
    },
    positionAb: {
      position: "absolute",
      right: 2,
      top: 2,
      color: "#666666",
      textShadow: "0px 0px 2px #FFF",
      fontSize: "14px",
    },
    // publishedLabel: {
    //   position: "absolute",
    //   right: "0",
    //   left: "0",
    //   top: "4px",
    //   color: "#666666",
    //   textShadow: "0px 0px 2px #FFF",
    //   fontSize: "14px",
    //   cursor: "pointer",
    // },
    positionRl: {
      position: "relative",
    },
    icon: {
      color: theme.palette.primary.contrastText,
      borderRadius: 15,
      padding: "3px",
      margin: 0,
      fontSize: 28,
    },
    editIcon: {
      fontSize: 16,
    },
    connectorLine: {
      borderColor: "transparent",
      margin: "0px -2px 0px",
    },
    defaultIcon: {
      backgroundColor: theme.palette.primary.contrastText,
    },
    p15: {
      padding: theme.spacing.unit * 2,
      height: "auto",
      overflow: "auto",
    },
    overflowSection: {
      overflow: "auto",
      height: "auto",
      padding: '7px',
      backgroundColor: 'transparent',
      "&>:nth-child(2)": {
        padding: 0,
      },
    },
    focusedStep: {
      backgroundColor: '#FAFCFF',
      padding: '10px 10px 10px 0',
      borderRadius: "4px",    
    },
    innerConnecter: {
      "&:after": {
        minHeight: "32px",
        borderLeftStyle: "solid",
        borderLeftWidth: "1px",
        margin: "21px -10px -5px",
        borderColor: "#E4E4E4",
        content: '""',
        marginTop: "20px",
        position: "absolute",
      },
    },
    progressBar: {
        borderRadius: 5
    },
    addOptionButton: {
      textAlign: "center",
    },
    moveToPlannedContainer: {
      marginTop: theme.spacing.unit * 3,
      marginBottom: theme.spacing.unit,
      marginLeft: -theme.spacing.unit * 2,
      marginRight: -theme.spacing.unit * 2,
      paddingLeft: theme.spacing.unit * 2,
      paddingRight: theme.spacing.unit * 2,
      position: "relative",
      borderTop: "1px solid #ededed",
    },
    moveToPlannedOr: {
      position: "absolute",
      left: "50%",
      transform: "translateY(-50%) translateX(-50%)",
      fontSize: "12px",
      background: "#ededed",
      color: "#adadad",
      padding: theme.spacing.unit,
      borderRadius: "100%",
    },
    moveToPlanned: {
      borderRadius: "18px",
      width: "100%",
      marginTop: theme.spacing.unit * 4,
    },
    modalBody: {
      width: "900px",
      paddingBottom: "47px",
      paddingTop: "35px",
      textAlign: "center",
    },
    publishText: {
      fontWeight: "normal",
      fontSize: "16px",
      lineHeight: "24px",
      textAlign: "center",
      width: "577px",
      margin: "20px auto 0 auto",
      display: "block",
    },
    quesIdContainer: {
      padding: "15px",
      width: "100%",
      textAlign: "center",
    },
    quesId: {
      border: "solid 1px #2196F3",
      color: "#2196F3",
      padding: "5px 14px 5px 14px",
      textAlign: "center",
      fontSize: "16px",
      lineHeight: "16px",
      borderRadius: "4px",
      textDecoration: "none",
      margin: "10px",
      background: "#ffffff",
    },
    modalFooter: {
      textAlign: "center",
      padding: "10px 0 20px 0",
    },
    refreshBtn: {
      color: "#ffffff",
      padding: "0 16px",
      background: "linear-gradient(90deg, #2E93FB 0%, #66b4fd 70%)",
      height: "36px",
      fontSize: "0.875rem",
      minWidth: "64px",
      boxSizing: "border-box",
      lineHeight: "1.75",
      fontFamily: "'Roboto', sans-serif",
      "font-weight": "normal",
      borderRadius: "4px",
      backgroundColor: "#2E93FB",
      border: "solid 1px #2E93FB",
      display: "inline-block",
      width: "140px",
    },
    okBtn: {
      color: "#2E93FB",
      padding: "0 16px",
      background: "#ffffff",
      height: "36px",
      fontSize: "0.875rem",
      minWidth: "64px",
      boxSizing: "border-box",
      lineHeight: "1.75",
      fontFamily: "'Roboto', sans-serif",
      "font-weight": "normal",
      borderRadius: "4px",
      marginLeft: "18px",
      display: "inline-block",
      width: "140px",
      border: "solid 1px #2E93FB",
    },
    republishTitle: {
      color: "#333333",
      fontSize: "24px",
      fontWeight: 600,
    },
    customRepublishDialog: {
      minWidth: "550px",
      width: "100%",
    },
    cancelBorder: {
      border: "1px solid #1D7DEA",
    },
    footerFixed: {
      position: "fixed",
      zIndex: 100,
      right: 0,
      width: "100%",
      bottom: 0,
      textAlign: "right",
      backgroundColor: "#ffffff",
      paddingRight: "26px",
      padding: '15px 24px',
      boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
      display: 'flex',
      justifyContent: 'flex-end',
      gridTemplateColumns: '85% 15%',
      alignItems: 'center',
      '& .instruction': {
        margin: '0 auto 0 0',
        width: '50%',
        maxWidth: '473px',
        fontSize: '20px',
        fontWeight: 400,
        color: '#666666',
        textAlign: 'left'
      },
      '& button':{
        padding: "10px 15px",
        // maxWidth: 140,
        // width: "100%",    
    }
    },
    footerForReValidation: {
      gridTemplateColumns: 'auto 205px 205px',
      gap: '15px',
    },
    //   progressBar: {
    //     borderRadius: 5
    //   },
    linearProgressBar: {
      borderRadius: 5,
      padding: 2,
      margin: "4px 8px",
      backgroundColor: "#E8E8E8",
      width: "82px",
      minWidth: 85,
      display: "inline-block",
      verticalAlign: "middle",
    },
    progressPercent: {
      fontSize: 14,
      color: "#333",
      fontWeight: 600,
    },
    colorSecondary: {
      backgroundColor: "#EB4F4F",
      color: "5.5px 5px 5px 5.5px",
    },
    colorprimary: {
      backgroundColor: "#67BF02",
    },
    colorSuccess: {
      backgroundColor: "#67BF02",
      color: "5.5px 5px 5px 5.5px",
    },
    progressLabel: {
      fontSize: 14,
      color: "#999",
    },
    progressCount: {
      fontSize: 14,
      color: "#333",
      fontWeight: 600,
    },
    progressParent: {
      display: "flex",
      alignItems: "center",
    },
    displayFlex:{
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row-reverse",
        maxWidth: 220,
        width: "100%",
        marginLeft: "auto",
    },
    cursorPointer:{
        cursor: 'pointer',
    },
    numberLabel:{
      width: 28,
      height: 28,
      borderRadius: "50%",
      border: "1px solid #dcdcdc",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    btnText: {
      border: 'none !important',
      fontSize: '14px',
      fontWeight: 600,
      color: '#1D7DEA !important',
      whiteSpace: 'nowrap',
      '&:disabled': {
        opacity: 0.41,
      }
    },
    btnFill: {
      fontSize: '14px',
      fontWeight: 600,
      padding: '5px 10px',
      whiteSpace: 'nowrap',
    },
    progressText: {
      justifyContent: 'inherit',
    },
    rejectionModal: {
      textAlign: 'center',
      maxWidth: '400px',
      margin: '0 auto',
      '& img': {
        display: 'block',
        margin: '0 auto 33px',
      },
      '& h2': {
        fontSize: '24px',
        fontWeight: 600,
        lineHeight: '138%',
        color: '#333333',
        margin: '0 0 10px',
      },
      '& p': {
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '150%',
        color: '#666666',
        margin: '0 0 20px',
      }
    },
    rejectionModalFooter: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      margin: '0 0 16px',
      '& .modalBtnText': {
        fontSize: '16px',
        fontWeight: 500,
        color: '#1D7DEA',
        padding: '5px 10px',
        minHeight: '44px',
        minWidth: '94px',
        margin: '0 4px',
      },
      '& .modalBtnFill': {
        fontSize: '16px',
        fontWeight: 500,
        color: '#ffffff',
        backgroundColor: '#1D7DEA',
        minWidth: '94px',
        padding: '5px 10px',
        minHeight: '44px',
        margin: '0 4px',
      }
    }
  });

//@ts-ignore
interface SectionsInContentWithProps extends WithStyles<typeof styles> {
    classes: any,
    originalFormData: any,
    formData: any,
    validations: any,
    formDataError: ContentFormDataError,
    changeFormDataError: Function,
    match: any,
    eventInContent: any,
    history: any,
    queryParams: any,
    paragraphInSection: any,
    completionPercent: any,
    alternateAnswer: boolean,
    isValidAttempts: boolean,
    defaultCorrectAnswer: any,
    content: any,
    tagsList: ContentTagData[],
    updateFormData: Function,
    moveToPlanned: Function,
    publishContent: Function,
    fromURL: any,
    selectedQuestionsList: any[],
    publishedStateQuestion: any[],
    draftStateQuestion: any[],
    completeDraftStateQuestion: any[],
    testSubjects: any[],
    save: Function,
    // question content data
    title: string,
    optionsContent: any,
    type: string,
    subType: any,
    subjects: any,
    secondarySubjects: any[],
    difficultyLevel: any,
    difficultyType: any,
    relevantExams: any,
    tags: any,
    correctAnswer: any,
    customAnswer: boolean,
    solutionContent: string,
    stepWiseSolution: StepWiseSolution[],
    questionHints: string,
    matrixOptionContent: any,
    draftId: any,
    contentSubtype: {
        list: ContentSubtypeData[],
        question: ContentSubtypeData[],
        testpapers: ContentSubtypeData[],
    },
    allQuestionBenchmarks: AllQuestionBenchmarks,
    updateQuestionBenchmarks: any;
    idealTime: any;
    authenticatedUser: any;
    requestId: string,
    setAccordingTouchIndex: any,
    setIsComingFrom: Function,
    setAccordianTouchWhileCreate: Function,
    accordianCreateTouched: any,
    fromFeedback: boolean,
    sliderData?: any;
    currentQuestionNumber?: number,
    currentTestNumber: number,
    authorType: string;
    feedBackData: any;
    onFeedbackPublish?: Function,
    setIsTabOpened: Function,
    setAccordianState: Function,
    setProgressBarForQuestion: Function,
    setFilterQuestionArray: Function,
    setContentRequestItemsIdForFirstTime: Function,
    setRemoveUnresolvedFeedbackCount: Function,
    contentRequestItemsIdForFirstTime: string;
    focusedSection: { currentlyFocusedSection: string; sectionsTouched: Set<string> };
    questionPreviousExams:{[key:string]:PreviousExamItem[]},
    setPreviousExams:Function,
    showMsg:Function,
    concepts: any;
    pendingValidationComments?: boolean;
    validationStatus?: string;
    canSubmitToAnotherValidator?: boolean;
    finalQuestionBenchmarksPayload: any;
    syllabusExams: any;
    remedialQuestionIds: any;
}

interface SectionsInContentWithStates {
    inContent: any,
    isPageLoaded: boolean,
    previousEventInContent: any,
    isAuthorDialogOpen: boolean,
    isPublishedDialogOpen: boolean,
    isReviwerDialogOpen: boolean,
    selectedAuthors: any,
    questionId: any,
    draft100Percent: any,
    draftLessThan100Percent: any,
    rePublishContentId: string,
    addToQueueStates: ADD_TO_QUEUE_STATES,
    isAlreadyInAddToQueue: boolean,
    alreadyInAddToQueueMsg: string,
    reasonRepublishPopup: boolean,
    userSelectedFromAuthors: any,
    republishQueue: string,
    submitToAnotherValidatorClicked: boolean,
    isChallengeRejectionModalOpen: boolean,
    publishDialogBody: string,
    publishDialogHeading: string,
    publishQuestionDirectly: boolean,
    isPublishDirectlyModalOpen: boolean,
    disablePubliushDirectlyButton:  boolean,
}

enum ADD_TO_QUEUE_STATES {
    DEFAULT = 0,
    DIELOG_OPEN,
    DONE
}

const validationKeys = ["questionContent", "optionsContent", "correctAnswer", "mapSyllabus", "addDifficultySkills", "solutions", "addTags", "addBenchmarking"];

//TODO sift this on utils later 
export const _calCulateProgressBar = function (validations: any) {
    const progressBarSetting: any = {}
    let sucess = 0
    let total = 0
    validations && Object.keys(validations).forEach((key: any) => {
        total += 1
        if (validations[key].status == statusType.success) {
            sucess += 1
        }
    })

    progressBarSetting.barPercentage = ((sucess / total) * 100).toFixed(2)
    // TODO - looking like we can remove bar length in future 
    progressBarSetting.barLength = parseInt(progressBarSetting.barPercentage)
    return progressBarSetting;
    // this.props.completionPercent(this.props.formData, progressBarSetting.barLength);
}

class SectionsInContentQuestion extends Component<SectionsInContentWithProps, SectionsInContentWithStates>{
    constructor(props: SectionsInContentWithProps, state: SectionsInContentWithStates) {
        super(props);
        // TODO remove unnecessary state later 
        this.state = {
            inContent: [],
            isPageLoaded: true,
            //This will help for setTimeOut
            previousEventInContent: {},
            isAuthorDialogOpen: false,
            isPublishedDialogOpen: false,
            isReviwerDialogOpen: false,
            selectedAuthors: [],
            questionId: "",
            draft100Percent: [],
            draftLessThan100Percent: [],
            rePublishContentId: '',
            addToQueueStates: ADD_TO_QUEUE_STATES.DEFAULT,
            isAlreadyInAddToQueue: false,
            alreadyInAddToQueueMsg: '',
            reasonRepublishPopup: false,
            userSelectedFromAuthors: null,
            republishQueue: '',
            submitToAnotherValidatorClicked: false,
            isChallengeRejectionModalOpen: false,
            publishDialogBody: '',
            publishDialogHeading: '',
            publishQuestionDirectly: false,
            isPublishDirectlyModalOpen: false,
            disablePubliushDirectlyButton: false,
        };
        this.publishContent = this.publishContent.bind(this);
        const allStates: any = localStorage.getItem('allStates');
        const previousStates = JSON.parse(allStates);
    }

    componentDidUpdate() {
        if (this._checkForAddToQueueModeActive()) {
            window.onbeforeunload = () => true
        } else {
            //@ts-ignore
            window.onbeforeunload = undefined
        }
    }
    componentDidMount = () => {
        if (this.props.requestId) {
            setTimeout(() => {
                const { setAccordianTouchWhileCreate } = this.props;
                const allStates: any = localStorage.getItem('allStates');
                const previousStates = JSON.parse(allStates);
                const { contentRequestData: { contentRequestAccordianData: { accordianCreateTouched = {} } = {} } = {}
                } = previousStates;
                setAccordianTouchWhileCreate(accordianCreateTouched)
            }, 100);
        }
      const { fromURL } = this.props;
      const urlParams = new URLSearchParams(fromURL);
      const value = urlParams.get('publishDirectly');
      if(value) {
        this.setState({
          publishQuestionDirectly: true,
          disablePubliushDirectlyButton: true,
        });
      }
    }
    onSectionClick = (sectionLabel: string) => {
        scrollIntoView(_.camelCase(sectionLabel));
        sectionLabel === 'Add Difficulty & Skills' && this.scrollToTheContent('addDifficultyAndSkills');
        sectionLabel === 'Add Benchmarking' && this.scrollToTheContent('addBenchmarking');
    }

    scrollToTheContent(id: string) {
      //@ts-ignore
      document.getElementById(id).scrollIntoView({ behavior: 'smooth', top: '100px' });
    }

    stepLabelType(label: string, type: statusType, sectionNo: number): any {
        const { classes, focusedSection: { currentlyFocusedSection } } = this.props;
        const isCurrentlyEditing = _.camelCase(label) === currentlyFocusedSection;
        
        return (<StepLabel className={classNames(isCurrentlyEditing && classes.focusedStep)} onClick={() => this.onSectionClick(label)} icon={this.stepLevelIconType(label, type, sectionNo, isCurrentlyEditing)}><Typography className={classes.cursorPointer} variant="body1">{label}</Typography></StepLabel>)
        
        
    }


    stepLevelIconType(label: string, type: statusType, sectionNo: number, isCurrentlyEditing: boolean) {
        let { classes } = this.props;
        if(isCurrentlyEditing) {
          return (<EditOutlinedIcon className={`${classes.icon} ${classes.primaryColor}`} />)
        }
        switch (type) {
            case statusType.edit:
                return (<EditOutlinedIcon className={`${classes.icon} ${classes.primaryColor}`} />)
            // case statusType.warning:
            //     return (<ErrorOutline className={`${classes.icon} ${classes.warningIcon}`} />)
            case statusType.success:
                return (<Check className={`${classes.icon} ${classes.successIcon}`} />)
            default:
              return (<StepLabel><Typography className={classes.numberLabel} variant="body1">{sectionNo}</Typography></StepLabel>)
        }
    }

    beforeAuthorPublishDialogue() {

        const progressBarSetting = calCulateProgressBar(this.props.validations, this.props.content);
        let { content,questionPreviousExams, } = this.props;
        if (["REVIEW"].includes(content.status)) {
            //"PUBLISHED", 
            return false;
        }
        if (progressBarSetting.barPercentage == 100) {
            let reviwers = ACLService.getUserReviewer();
            if (reviwers && reviwers.length > 0) {
                //content not eligible to publish 
                this.setState({ isReviwerDialogOpen: true });
            } else {
                this.setState({ isAuthorDialogOpen: true });
            }
        } else {
            return false;
        }

    }



    getFormData = (formData: any, subType: any) => {
        const { contentSubtype,questionPreviousExams,setPreviousExams } = this.props;
        let {type } = this.props.queryParams;
        let hasValidPrevExam=true;
        if (!formData.content[0]) {
            formData.content[0] = {}
        }
        const settings = _.get(formData, 'settings', {});
        const { value, state } = this.props.idealTime
        settings.idealTime = getTimeInSecs(value, state)
        settings.idealTimeToSolve = getTimeInSecs(value, state)
        formData.settings = settings;
        formData.content[0].questionContent = this.props.title
        formData.content[0].questionHints = this.props.questionHints
        formData.content[0].solutionContent = this.props.solutionContent
        formData.content[0].optionsContent = this.props.optionsContent
        formData.content[0].stepWiseSolution = this.props.stepWiseSolution[0]
        formData.content[0].matrixOptionContent = this.props.matrixOptionContent
        formData.content[0].correctAnswer = this.props.correctAnswer
        formData.content[0].customAnswer = this.props.customAnswer


        //formData.subjects = this.props.subjects
        formData.difficultyLevel = this.props.difficultyLevel
        formData.difficultyType = this.props.difficultyType
        formData.relevantExams = this.props.relevantExams
        formData.tags = this.props.tags
        formData.subjects = this.props.subjects;

        if(this.props.secondarySubjects) {
          formData.secondarySubjects = this.props.secondarySubjects
        }

        // fill question code and question type
        formData.questionCode = parseInt(subType);
        _.get(contentSubtype, "question", []).forEach(st => {
            if (subType == parseInt(st.code)) {
                formData.questionType = st.name;
            }
        });
        if(type==='question'&& questionPreviousExams){
          let { subType, } = this.props.queryParams;
            formData.content.forEach((c:any)=>{
              let questionId=subType!=5?formData._id:c.paragraphQuestionId;
              if(!Array.isArray(questionPreviousExams[questionId])){
                return ;
               } 
              let result=getGenericPrevExams(questionId,questionPreviousExams);
             if(subType!=5){
               formData.previousExams=result[0];
             }else{
              c.previousExams=result[0];
             } 
              if(result[1]){
                //  this.props.setPreviousExams({questionId:questionId, data:result[2]});
                hasValidPrevExam=false;
              }
            })
        }
        const currCorrectAnswer = (((formData.content || [])[0] || {}).correctAnswer || []);
        if(subType === String(QUESTION_TYPES.BLANKS) && type === AUTHORING_CONTENT_TYPES.GLORIFIRE_QUESTION && Array.isArray(currCorrectAnswer)){
          const correctAnswer = currCorrectAnswer.map((answer:any) => {
            return {
              value: answer.value,
              weightage: 0
            }
          });
          ((formData.content || [])[0] || {}).correctAnswer = {
            answerType: "id",
            data: correctAnswer
          }
        }
        return {formData,hasValidPrevExam}
        // }else{
        // 	handleFormSubmit();
        // }

    }

    setReview(isSelected: boolean, userId: string) {
        let { formData } = this.props;
        if (isSelected && formData) {
            formData["contentReviewer"] = userId;
            formData["status"] = "REVIEW";
            this.setState({ isReviwerDialogOpen: false });
            this.props.updateFormData(formData, true);
        } else {
            this.setState({ isReviwerDialogOpen: false });
        }
    }

    moveToPlanned() {
        this.props.moveToPlanned();
    }

    getButtonText(contentType: string) {
        let { sliderData, currentTestNumber, currentQuestionNumber, authorType } = this.props;
        let contentTypeCondition: any = contentType === 'testpapers' ? currentTestNumber : currentQuestionNumber;
        if ((sliderData && sliderData.contents && sliderData.contents.length > 1) && (contentTypeCondition < sliderData.contents.length)) {
          if(authorType !== 'creator') {
            return 'Verify and Next'
          } else {
            return 'Save and Next'
          }
        } else {
          if(authorType !== 'creator') {
            return 'Verify and Proceed'
          } else {
            return 'Save and Proceed'
          }
        }
    }

    _getButtonName() {
        const { content, requestId } = this.props;
        if (requestId) {
            let status = 'Save and Next'
            return status;
        } else {
            let reviwers = ACLService.getUserReviewer();
            let status = 'Publish';

            if (reviwers && reviwers.length > 0) {
                status = 'Submit for Review'
            }
            else {
                status = 'Publish'
            }
            if (["PUBLISHED", "REVIEW"].includes(content.status)) {
                status = 'Re-Publish';
            }
            return status;
        }
    }

    togglePublishDialogOpen = () => this.setState({ isPublishedDialogOpen: false })

    // RePublishContent = async (usersSelected: any) => {
    //     // const { selectedAuthors } = this.state
    //     // let progressBarSetting = calCulateProgressBar(this.props.validations);
    //     let { formData } = this.props
    //     let { subType, type } = this.props.queryParams;
    //     if (type == "studymaterial" && subType != "notes") {
    //         type = subType;
    //     }
    //     let authors = [usersSelected]
    //     formData.completionPercent = 100
    //     formData.authors = usersSelected
    //     formData.status = "PUBLISHED";
    //     formData = this.getFormData(formData, subType)

    //     if (formData._id) {
    //         contentService
    //             .save(formData._id + 'question', 'question', formData, false)
    //             .then(() => {
    //                 formData.draftId = this.props.draftId
    //                 contentService.rePublish(formData, authors, type, true)
    //                     .then((res: any) => {
    //                         this.setState({ isPublishedDialogOpen: true, rePublishContentId: res.contentId });
    //                     });
    //             })
    //     }
    //     // this.setState({ selectedAuthors: authors });
    // }
    redirectToContentRequest = (res: any) => {
        const allStates: any = localStorage.getItem('allStates');
        const previousStates = JSON.parse(allStates);
        const { contentRequestData: { contentRequestData: { _id = '' } = {}, contentRequestAccordianData: { accordianTouched = [], accordianState = [], progressBarForQuestion, filteredQuestionArray, contentRequestItemsIdForFirstTime, removeUnresolvedFeedbackCount } }
        } = previousStates;
        const { accordianCreateTouched = {}, history } = this.props;
        const { accordianIndex = 0, questionIndex = 1 } = accordianCreateTouched;
        let newUpdatedAccordianTouchedArray: any = [];
        let newQuestionFilter: any = [...filteredQuestionArray];
        accordianTouched.map((acc: any, index: number) => {
            if (acc.accordianIndex === accordianIndex) {
                const { questionContent = [] } = acc;
                const findQuestionIndex = questionContent.findIndex((element: any) => element.questionIndex === questionIndex);
                if (index !== -1) {
                    const newUpdatedAttachedQuestion = {
                        content_Id: res._id,
                        contentId: res.contentId,
                        isJobCompleted: false,
                        isTouched: true,
                    }
                    newQuestionFilter.push({ content_Id: res._id, contentId: res.contentId, contentSubTypeCode: res.questionCode })
                    const newUpdatedAccordianTouchedObject = { ...newUpdatedAttachedQuestion };
                    let updatedQuestionContentArray = [...questionContent];
                    updatedQuestionContentArray[findQuestionIndex] = { ...updatedQuestionContentArray[findQuestionIndex], attachedQuestions: { ...newUpdatedAccordianTouchedObject, unresolvedFeedbackCount: updatedQuestionContentArray[findQuestionIndex]['attachedQuestions'].unresolvedFeedbackCount, previousVersion: { ...updatedQuestionContentArray[findQuestionIndex]['attachedQuestions'].previousVersion } } }
                    newUpdatedAccordianTouchedArray = [...accordianTouched];
                    newUpdatedAccordianTouchedArray[index] = {
                        ...newUpdatedAccordianTouchedArray[index],
                        questionContent: [
                            ...updatedQuestionContentArray,
                        ]
                    }
                }
            }
        })
        const { setAccordingTouchIndex } = this.props;
        setAccordingTouchIndex(newUpdatedAccordianTouchedArray);
        setTimeout(() => {
            this.props.setAccordianState(accordianState);
            this.props.setProgressBarForQuestion(progressBarForQuestion);
            this.props.setContentRequestItemsIdForFirstTime({ id: contentRequestItemsIdForFirstTime });
        }, 200);
        this.props.setIsComingFrom({ booleanValue: true });
        this.props.setIsTabOpened({ booleanValue: true });
        this.props.setFilterQuestionArray(newQuestionFilter);
        this.props.setRemoveUnresolvedFeedbackCount({
          removeUnresolvedFeedbackCount
        });
        window.close()
        //history.push(`/contentRequest/owner-task/${_id}/creator`);
    }

  restructureSubjects(subjects: any[]) {
    return subjects.map(subject => {
      if (typeof subject !== 'object' || subject === null) {
        return subject;
      }
      Object.keys(subject).forEach(key => {
        if (Array.isArray(subject[key])) {
          if (subject[key].length > 0) {
            subject[key] = [this.restructureSubjects([subject[key][0]])[0]];
          } else {
            subject[key] = [];
          }
        } else if (typeof subject[key] === 'object') {
          subject[key] = this.restructureSubjects([subject[key]])[0];
        }
      });
      return subject;
    });
  }
    publishContent(usersSelected: any, mode: 'PUBLISH' | 'REPUBLISH') {
        let { formData, allQuestionBenchmarks, updateQuestionBenchmarks } = this.props;
        if (!_.isEmpty(allQuestionBenchmarks)) {
            Object.keys(allQuestionBenchmarks).forEach(questionId => {
                updateQuestionBenchmarks({ questionId })
            })
        }
        const studentUser = getUserType(USER_TYPE.STUDENT);
        formData = createDeepCopy(formData);
        if (studentUser && formData.subjects) {
          formData.subjects = this.restructureSubjects([formData.subjects[0]]);
        }
        let { subType, type } = this.props.queryParams;
        // const { selectedAuthors } = this.state;
        // const progressBarSetting = calCulateProgressBar(this.props.validations);
        if (type == "studymaterial" && subType != "notes") {
            type = subType;
        }
        const isTeacher = checkForTeacherUser(this.props.content);
        const {content} = this.props;
        const isCreatorTeacher = getPropertyValue(content, 'contentTypeCode') === CONTENT_TYPE.QUESTION && getPropertyValue(content, 'isCreatorTeacher');
        // let authors = [...selectedAuthors, usersSelected]
        formData.authors = usersSelected
        formData.completionPercent = 100
        formData.status = (isTeacher || isCreatorTeacher) ?  CONTENT_STATES.DRAFT : CONTENT_STATES.PUBLISHED;
        formData.syllabusExams = this.props.syllabusExams[this.props.content.content_Id];
         const result:any = this.getFormData(formData, subType)
         formData=result.formData;
        if(!result.hasValidPrevExam){
            this.props.showMsg("Select atleast one year under Previous Year Question Section","error");
            return ;   
        }
        formData.remedialQuestionIds = this.props.remedialQuestionIds[PROPS_REMEDIAL_KEY.DEFAULT]
        contentService
            .save(formData._id + 'question', 'question', formData, false)
            .then((res: any) => {
                // add draftid to resolve undefined error
                const { draftId, requestId } = this.props
                formData.draftId = res.draftId ? res.draftId : draftId;
                formData.publishId = res.responseObject.draftId ? res.responseObject.draftId && res.responseObject.draftId.publishId : formData.publishId;
                if(_.isEmpty(formData.publishId)){
                  formData.publishId = res.responseObject._id
                }
                if(!formData.publishId) {
                  return;
                }
                const { publishQuestionDirectly } = this.state;
                if (publishQuestionDirectly) {
                  formData.publishBeforeValidation = true;
                }
                if ((isTeacher || isCreatorTeacher)) {
                  const payload = {...formData};
                  if (res.responseObject.draftId && content.status === CONTENT_STATES.PUBLISHED) {
                    payload._id = res.responseObject.draftId._id;
                    payload.contentId = res.responseObject.draftId.contentId;
                  }
                  this.submitForValidation(payload, usersSelected);
                  return;
                }
                if (mode === 'PUBLISH') {
                    contentService
                        .publish(formData, usersSelected, type)
                        .then((res) => {
                            if (this.props.fromFeedback && this.props.onFeedbackPublish) {
                                this.props.onFeedbackPublish();
                                this.setState({
                                    isPublishedDialogOpen: false,
                                    questionId: formData._id,
                                    rePublishContentId: res.contentId
                                });
                            } else {
                                this.setState({
                                    questionId: formData._id,
                                    isPublishedDialogOpen: true,
                                    rePublishContentId: res.contentId
                                })
                            }
                            if (requestId && !this.props.fromFeedback) {
                                this.redirectToContentRequest(res)
                            }
                        });
                } else {
                    if (this.state.republishQueue) {
                        formData.republishReason = this.state.republishQueue
                    }
                    contentService
                        .rePublish(formData, usersSelected, type, true)
                        .then((res: any) => {
                            if (this.props.fromFeedback && this.props.onFeedbackPublish) {
                                this.props.onFeedbackPublish();
                                this.setState({
                                    isPublishedDialogOpen: false,
                                    questionId: formData._id,
                                    rePublishContentId: res.contentId
                                });
                            } else {

                                const params:any={
                                  questionId: res._id,
                                  reviewerType: 'all',
                                  reviewStatus: 'open,accepted',
                                  pageNumber: 1,
                                }
                                if (res.aclMetaData.createdBy.id !== res.aclMetaData.updatedBy.id) {
                                  params.reviewerId = res.aclMetaData.updatedBy.id;
                                }

                                contentService.getQuestionReviews(params).then(response => {

                                  if (response.totalRecords > 0) {

                                    const { history, match } = this.props;
                                    const questionData = res.content[0].questionContent.replace(/<\/?[^>]+(>|$)/g, "");
                                    if (res.aclMetaData.createdBy.id === res.aclMetaData.updatedBy.id){
                                      history.push(`/sendNotification/${res.contentId}/${res.questionCode}/${res.questionType}/${res._id}/${questionData}`);
                                    } else {
                                      history.push(`/sendNotification/${res.contentId}/${res.questionCode}/${res.questionType}/${res._id}/${res.aclMetaData.updatedBy.id}/${questionData}`);
                                    }
                                  } else {

                                    this.setState({
                                      isPublishedDialogOpen: true,
                                      questionId: formData._id,
                                      rePublishContentId: res.contentId,
                                      reasonRepublishPopup: false
                                    });
                                  }

                                })
                            }
                            if (requestId && !this.props.fromFeedback) {
                                this.redirectToContentRequest(res)
                            }

                        });
                }
            })
        // this.setState({ selectedAuthors: authors });
    }

    submitForValidation(formData: any, usersSelected: any) {
      _.set(formData, 'content[0].benchmarks', this.props.finalQuestionBenchmarksPayload[formData._id]);
      const body = {
        ...formData,
        authors: usersSelected,
        contentType: 'question',
      };
      let publishDialogContent = !this.props.validationStatus ? CONTENT_SUBMIT_MODAL_BODY.SUBMIT : CONTENT_SUBMIT_MODAL_BODY.RE_SUBMIT;
      if (this.state.submitToAnotherValidatorClicked) {
        body.submitToAnotherValidator = true;
        publishDialogContent = CONTENT_SUBMIT_MODAL_BODY.SUBMIT_TO_ANOTHER_VALIDATOR;
      }
      if (this.state.publishQuestionDirectly) {
        publishDialogContent = CONTENT_SUBMIT_MODAL_BODY.DIRECT_PUBLISH
      }
      contentRequestServices.submitContentForValidation(body).then((res: any) => {
        this.setState({
          isPublishedDialogOpen: true,
          publishDialogBody: publishDialogContent.body,
          publishDialogHeading: publishDialogContent.heading,
        });
      })
    }

    checkFieldsUpdated(originalData: any,formData: any): string[]{
      const fields = [];
      for(const key in originalData){
        if(key==='authors') continue;
        if(!_.isEqual(originalData[key],formData[key])){
          fields.push(key);
        }
      }
      return fields;
    }

    addToQueue(usersSelected: any, override?: any) {
        const {
            correctAnswer,
            defaultCorrectAnswer,
            alternateAnswer,
            originalFormData,
            content,
            subjects,
            difficultyLevel,
            difficultyType
        } = this.props;
        let { formData, secondarySubjects } = this.props;
        let { subType, type } = this.props.queryParams;
        // const { selectedAuthors } = this.state;
        // const progressBarSetting = calCulateProgressBar(this.props.validations);
        if (type == "studymaterial" && subType != "notes") {
            type = subType;
        }
        // let authors = [...selectedAuthors, usersSelected]
        formData.authors = usersSelected
        this.setFormValues(formData);
        if (override.override) {
            formData.addToQueueOverride = true
        }

        const result:any = this.getFormData(formData, subType)
        formData = JSON.parse(JSON.stringify(result.formData));
        let conceptId: any[] = [];
        let conceptCodes: any[] = [];
        if(!result.hasValidPrevExam){
          this.props.showMsg("Select atleast one year under Previous Year Question Section","error");
          return ;   
        }
        if (alternateAnswer) {
            formData.content[0].alternateAnswer = true;
            formData.content[0].optionChange = false;
        } else {
            formData.content[0].optionChange = !checkIsCorrectAnswerChange(defaultCorrectAnswer, correctAnswer);
            formData.content[0].alternateAnswer = false;
        }
        const originalDifficultyLevel=content.difficultyLevel;
        const originalDifficultyType=content.difficultyType;
        const originalSubjects=content.subjects;
        const originalSecondarySubjects=content.secondarySubjects;
        secondarySubjects = originalSecondarySubjects;
        formData.secondarySubjects = originalSecondarySubjects;
        formData.content[0].difficultySkillLevelChange=checkIsDifficultyAndSkillChange(
          difficultyLevel,
          difficultyType, 
          originalDifficultyLevel,
          originalDifficultyType
        )
        formData.content[0].conceptChange=checkIsConceptAndChapterChange(
          subjects,
          secondarySubjects,
          originalSubjects,
          originalSecondarySubjects
        )
        if (formData.subjects) {
          convertSubjectWithId(formData.subjects, conceptId, conceptCodes);
        }
        if (formData.secondarySubjects) {
          convertSubjectWithId(formData.secondarySubjects, conceptId, conceptCodes);
        }
        if (override.republishQueue) {
            formData.republishReason = override.republishQueue
        }
        formData.status = "PUBLISHED";
        if(this.props.concepts) {
        formData.concepts = this.props.concepts;
        formData.conceptId = this.props.concepts.map((item: any)=> item.id);
        }

        let chapterConceptArray: any[] = [];
        formData.subjects.forEach((item: any) => {
          chapterConceptArray = [];
          item.subSubjects.forEach((subject: any) => {
            subject.chapters.forEach((chapter: any) => {
              if (chapter.concepts.length) {
                chapterConceptArray.push(chapter);
              }
            });
          });
          item.chapters = chapterConceptArray;
        });
        // TODO - add option change data here 
        contentService
            .addToQueueQuestion(formData, usersSelected, type)
            .then((res) => {
                if (res.statusCode == 422) {
                    this.setState({
                        isAlreadyInAddToQueue: true,
                        isAuthorDialogOpen: false,
                        alreadyInAddToQueueMsg: res.responseMessage
                    })
                } else {
                    this.setState({
                        // questionId: formData._id,
                        // isPublishedDialogOpen: true,
                        addToQueueStates: ADD_TO_QUEUE_STATES.DONE,
                        isAuthorDialogOpen: false,
                        isAlreadyInAddToQueue: false,
                    })
                }
            });
        // this.setState({ selectedAuthors: authors });
    }

   setFormValues(formData:any): void{
    const {content} = this.props;
    formData.completionPercent = 100;
    formData.type = "QUESTION";
    formData.content[0].alternateAnswer = false;
    const containsSetting = content && content.content && content.content.settings;
    if(containsSetting){
      containsSetting.idealTime = formData.settings.idealTime;
    }
   } 

    afterAuthorSelection = (isNotCancel: boolean, usersSelected: any) => {
      if (isNotCancel) {
        if (this._checkAccessToPublish()) {
          this.publishContent(usersSelected, "PUBLISH");
        } else if (this._checkForAddToQueueModeActive()) {
          const { content, alternateAnswer } = this.props;
          let {formData} = this.props;
          let { subType } = this.props.queryParams;
          const result: any = this.getFormData(formData, subType);
          formData = JSON.parse(JSON.stringify(result.formData));
          this.setFormValues(formData);
          if (alternateAnswer) {
            formData.content[0].alternateAnswer = true;
          }
          if (this.checkForQueueChange(content,formData)) {
            this.setState({
              selectedAuthors: usersSelected,
              addToQueueStates: ADD_TO_QUEUE_STATES.DIELOG_OPEN,
            });
          } else {
            this.setState({
              reasonRepublishPopup: true,
              isAuthorDialogOpen: false,
              userSelectedFromAuthors: usersSelected,
            });
          }
        } else {
          this.setState({
            reasonRepublishPopup: true,
            isAuthorDialogOpen: false,
            userSelectedFromAuthors: usersSelected,
          });
        }
      } else {
        this.setState({ isAuthorDialogOpen: false });
      }
    };
    checkForQueueChange(content: any, formData: any) {
      const { correctAnswer, defaultCorrectAnswer, alternateAnswer,
        difficultyLevel, difficultyType } = this.props;
      const originalDifficultyLevel = content.difficultyLevel;
      const originalDifficultyType = content.difficultyType;
      const questionCode = formData.questionCode;
      const optionsQuestion = [QUESTION_TYPES.MMCQ, QUESTION_TYPES.SMCQ];
      let fieldsupdated = this.checkFieldsUpdated(content.content, formData);
      const queueChanges = [];

      try {
        fieldsupdated = [...fieldsupdated, ...(this.checkFieldsUpdated(content.content.content[0], formData.content[0]))];
      } catch (error) {
        fieldsupdated.push('');
      }
      queueChanges.push(!checkIsCorrectAnswerChange(defaultCorrectAnswer, correctAnswer));
      queueChanges.push(checkIsDifficultyAndSkillChange(
        difficultyLevel,
        difficultyType,
        originalDifficultyLevel,
        originalDifficultyType
      ));
      queueChanges.push(fieldsupdated.some((property: string) => ADD_TO_QUEUE_PROPERTIES.includes(property)));
      queueChanges.push(alternateAnswer && optionsQuestion.includes(questionCode));

      return queueChanges.some(changes => changes);
    }
    closeRepublishDialog() {
        this.setState({
            reasonRepublishPopup: false,
            republishQueue: ''
        })
    }
    rePublish() {
        this.publishContent(this.state.userSelectedFromAuthors, 'REPUBLISH')
    }
    handleRepublishQueueChange(event: any) {
        const { value } = event.target;
        this.setState({
            republishQueue: value
        })
    }
    addToQueueDone = (isOverRide: any) => {
        this.addToQueue(this.state.selectedAuthors, isOverRide)
    }

    addToQueueCancel = () => {
        this.setState({
            addToQueueStates: ADD_TO_QUEUE_STATES.DEFAULT,
            isAlreadyInAddToQueue: false
        })
    }

    checkAccessToRePublish = () => {
        const { draftId, formData } = this.props;
        let status = false;
        if (draftId || formData.status === "PUBLISHED") {
            status = true
        }
        return status;
    }

    _checkAccessToPublish = () => {
        const { formData, content } = this.props;
        const isTeacher = checkForTeacherUser(this.props.content);
        const isCreatorTeacher = getPropertyValue(content, 'contentTypeCode') === CONTENT_TYPE.QUESTION && getPropertyValue(content, 'isCreatorTeacher');
        return formData.status === CONTENT_STATES.DRAFT || isTeacher || isCreatorTeacher;
    }

    checkRePublishMode = () => {
        const { formData } = this.props
        return formData.status == 'PUBLISHED'
    }
    checkDisabledConditionForNext() {
        return this.props.feedBackData && this.props.feedBackData.pendingFeedbacksCount !== 0
    }

    _checkForAddToQueueModeActive = () => {
        const {
            isValidAttempts,
            correctAnswer,
            defaultCorrectAnswer,
            alternateAnswer,
            difficultyLevel,
            difficultyType,
            subjects,
            secondarySubjects,
            originalFormData
        } = this.props;
        const originalDifficultyLevel=originalFormData.difficultyLevel;
        const originalDifficultyType=originalFormData.difficultyType;
        const originalSubjects=originalFormData.subjects;
        const originalSecondarySubjects=originalFormData.secondarySubjects;
        return isValidAttempts && (
            isQuestionAddToQueueModeActive({
            isValidAttempts,
            correctAnswer,
            defaultCorrectAnswer,
            alternateAnswer
        }) || isDifficultyAndSkillAddToQueueModeActive({
            difficultyLevel,
            difficultyType,
            originalDifficultyLevel,
            originalDifficultyType
        }) || isConceptAndChapterAddToQueueModeActive({
            subjects,
            secondarySubjects,
            originalSubjects,
            originalSecondarySubjects
        })
        )
    }

    _publishButtonOnClick = (progressBarSetting: any) => {
        if (!this.props.fromFeedback || (this.props.fromFeedback && !this.checkDisabledConditionForNext())) {
            if (parseInt(progressBarSetting.barPercentage) >= 100) {
                if (
                    this._checkAccessToPublish()
                    || this.checkAccessToRePublish()
                    || this._checkForAddToQueueModeActive()
                ) {
                    return this.afterAuthorSelection(true, [this.props.authenticatedUser.id]);
                    // return this.beforeAuthorPublishDialogue();
                }
            }
        }
    }

    submitToAnotherValidator = (progressBarSetting: any) => {
      this.setState({
        isChallengeRejectionModalOpen: false,
        submitToAnotherValidatorClicked: true,
      });
      this._publishButtonOnClick(progressBarSetting);
    }

    handleSubmitForValidationClick = (progressBarSetting: any) => {
      const {publishQuestionDirectly} = this.state;
      if(publishQuestionDirectly) {
        this.setState({isPublishDirectlyModalOpen: true});
        return;
      }
      this._publishButtonOnClick(progressBarSetting);
    }

    onPublishDirecltyModalClose = () => {
      this.setState({isPublishDirectlyModalOpen: false});
    }

    onPublishDirectlyClick = (progressBarSetting: any) => {
      this.setState({isPublishDirectlyModalOpen: false});
      this._publishButtonOnClick(progressBarSetting);
    }

    render() {

        const {
            classes,
            formData,
            history,
            queryParams,
            content,
            fromURL,
            validations
        } = this.props;
        const {
            isAuthorDialogOpen,
            rePublishContentId,
            isPublishedDialogOpen,
            isReviwerDialogOpen,
            selectedAuthors,
            questionId,
            addToQueueStates,
            isAlreadyInAddToQueue,
            alreadyInAddToQueueMsg,
            isChallengeRejectionModalOpen,
            publishDialogBody,
            publishDialogHeading,
            publishQuestionDirectly,
            isPublishDirectlyModalOpen,
            disablePubliushDirectlyButton,
        } = this.state;
        const progressBarSetting = calCulateProgressBar(validations, content)


        let sortedValidationKeys: string[] = [];
        if (validations !== null) {
            const keys = Object.keys(validations);
            validationKeys.forEach(validationKey => {
                if (keys.includes(validationKey)) {
                    sortedValidationKeys.push(validationKey)
                }
            })
        }
        let sectionNoToShow = 0;
        const isTeacher = checkForTeacherUser(this.props.content);
        const isStudentUser = getUserType(USER_TYPE.STUDENT);
        const isCreatorTeacher = getPropertyValue(content, 'contentTypeCode') === CONTENT_TYPE.QUESTION && getPropertyValue(content, 'isCreatorTeacher');
        const contentStatus = getPropertyValue(this.props.content, 'status', '').toUpperCase();
        const validationStatus = getPropertyValue(this.props.content, 'validationStatus', '').toUpperCase();
        const rejectedContentStatus = [contentStatus, validationStatus].includes(FEEDBACK_VALIDATOR_ACTIONS.REJECTED.toUpperCase());
        return (
          // <MyPATCollapse title={<Typography component="h3" variant="body2">Sections in This Content
          // <CustomInfoIcon
          //         infoDialogContentType="Goal Management"
          //         isInfoIcon={true}
          //         isRightArrow={false}
          //         isCenterArrow={true}
          //         knowMoreAbout={false}
          //         dialogTitle="Sections in This Content"
          //         imageURL="/assets/svg/infoIcon/createQuestion/window.svg"
          //         dialogPara="All the sections should be filled in order to publish the Question/ Test."
          //         details="Click to know more"
          //         toolTipDirection="top" />
          // </Typography>}>
          <>
            <Stepper
              className={classes.overflowSection}
              connector={
                <StepConnector
                  classes={{
                    disabled: classes.stepDisabled,
                    line: classes.connectorLine,
                  }}
                />
              }
              orientation="vertical"
            >
              {validations &&
                sortedValidationKeys.map((label) => {
                  if (label === "questionHints") {
                    if (content.content.mandatoryFields === undefined) {
                      // check for formData.mandatoryFields.hints here
                      return;
                    }
                  }
                  sectionNoToShow+=1;
                  return (
                    <Step>
                      {this.stepLabelType(
                        convertCamelCaseToText(label),
                        validations[label].status,
                        sectionNoToShow
                      )}
                    </Step>
                  );
                })}
            </Stepper>
            <Prompt
              when={this._checkForAddToQueueModeActive()}
              message="You have unsaved changes, are you sure you want to leave?"
            />

            <ContentAuthorModal
              onAuthorSelected={this.afterAuthorSelection}
              isAuthorDialogOpen={isAuthorDialogOpen}
            />
            {addToQueueStates === ADD_TO_QUEUE_STATES.DIELOG_OPEN && (
              <AddToQueueQuestion
                addToQueueCancel={this.addToQueueCancel}
                addToQueueDone={this.addToQueueDone}
                contentId={formData._id}
                isAlreadyInAddToQueue={isAlreadyInAddToQueue}
                alreadyInAddToQueueMsg={alreadyInAddToQueueMsg}
              />
            )}
            {isPublishedDialogOpen && (
              <ContentPublishedModal
                publishId={formData.publishId}
                rePublishContentId={rePublishContentId}
                isPublishedDialogOpen={isPublishedDialogOpen}
                content={content}
                queryParams={queryParams}
                history={history}
                fromURL={fromURL}
                togglePublishDialogOpen={this.togglePublishDialogOpen}
                authors={selectedAuthors}
                questionId={questionId}
                headingText={publishDialogHeading}
                bodyText={publishDialogBody}
              />
            )}
            {
              <MyPATDialog
                dialogOpen={this.state.reasonRepublishPopup}
                dialogHasActions={true}
                dialogHeading={
                  <Typography className={classes.republishTitle}>
                    Reason for Re-Publish
                  </Typography>
                }
                isAlignCenter={true}
                customButtonVariant="withoutBorderCloseIcon"
                isCustomBackground={false}
                onDialogClose={this.closeRepublishDialog.bind(this)}
                isborderDialogAction={true}
                customDialogActions={
                  <>
                    <Grid
                      container
                      justify="flex-end"
                      alignItems="flex-end"
                    >
                      <Button
                        color="primary"
                        className={classes.cancelBorder}
                        onClick={this.closeRepublishDialog.bind(this)}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        onClick={this.rePublish.bind(this)}
                        color="primary"
                      >
                        Re-publish
                      </Button>
                    </Grid>
                  </>
                }
              >
                <Grid
                  container
                  spacing={8}
                  className={classes.customRepublishDialog}
                >
                  <Grid item xs={12}>
                    <MyPATTextArea
                      inputId="republishReason"
                      name="republishReason"
                      placeholder="Enter reason here (Optional)"
                      onChange={this.handleRepublishQueueChange.bind(
                        this
                      )}
                      value={this.state.republishQueue}
                      multiline
                      fullWidthControl
                      className={classes.customTextarea}
                      rows="4"
                    />
                  </Grid>
                </Grid>
              </MyPATDialog>
            }
            <ContentReviwerModal
              onReviewSelected={this.setReview}
              isReviwerDialogOpen={isReviwerDialogOpen}
            />
            <Grid container className={[classes.footerFixed, isTeacher && this.props.canSubmitToAnotherValidator ? classes.footerForReValidation : ''].join(" ")}>
            {isTeacher && rejectedContentStatus && <p className='instruction'>Click on individual feedback and resolve/challenge all the feedback before proceeding further.</p>}
              {isTeacher && !isStudentUser && content.status === CONTENT_STATES.DRAFT && !content.validationStatus &&
                <div className={classes.directPublish}>
                  <span className={classes.directPublishText} >Publish this question within your centre directly to use it in a test or an assignment, while a duplicate of this question is undergoing validation</span>
                  <Switch
                    checked={publishQuestionDirectly}
                    disabled={disablePubliushDirectlyButton}
                    onChange={() => { this.setState({ publishQuestionDirectly: !publishQuestionDirectly }) }}
                    value="publishDirect"
                    color="secondary"
                    classes={{
                      switchBase: classes.iOSSwitchBase,
                      bar: classes.iOSBar,
                      icon: classes.iOSIcon,
                      iconChecked: classes.iOSIconChecked,
                      checked: classes.iOSChecked,
                    }}
                  />
                </div>
              }
              <Grid item>
                <Grid className={[classes.displayFlex, classes.progressText].join(' ')}>
                  <LinearProgress
                    classes={{
                      colorSecondary: classes.colorprimary,
                      barColorPrimary: classes.colorprimary,
                      bar: classes.progressBar,
                      root: classes.linearProgressBar,
                    }}
                    variant="determinate"
                    value={progressBarSetting.barLength}
                  />
                  <Typography
                    //   className={classes.positionAb}
                    //   variant="subtitle1"
                    align="center"
                  >
                    Progress: {Math.round((parseFloat(progressBarSetting.barPercentage) || 0) * 100) / 100} %

                  </Typography>
                </Grid>
                </Grid>
                {
                  (!isTeacher && !isCreatorTeacher) ?
                <Grid item>
                  <Button
                    color="primary"
                    variant="contained"
                    disabled={progressBarSetting.barPercentage < 100 || (this.props.fromFeedback && this.checkDisabledConditionForNext()) } 
                    onClick={() => {
                      this._publishButtonOnClick(progressBarSetting);
                    }}
                  >
     
                      {!this.props.fromFeedback
                        ? this._getButtonName()
                        : this.getButtonText("question")}
                    
                  </Button>
                </Grid>
                  :
                  <>
                    {
                      (!this.props.validationStatus || content.validationStatus === FEEDBACK_VALIDATOR_ACTIONS.PUBLISHED) && (
                        <Grid item>
                          <Button
                            color="primary"
                            variant="contained"
                            disabled={progressBarSetting.barPercentage < 100} 
                            onClick={() => this.handleSubmitForValidationClick(progressBarSetting)}
                          >
                            {QUESTION_SUBMIT.SUBMIT_FOR_VALIDATION}
                          </Button>
                        </Grid>
                      )
                    }
                    {
                      (this.props.validationStatus === FEEDBACK_VALIDATOR_ACTIONS.REJECTED) && (
                        <>
                          {
                            this.props.canSubmitToAnotherValidator && (
                              <Grid item>
                                <Button
                                  color="primary"
                                  variant="outlined"
                                  className={classes.btnText}
                                  disabled={progressBarSetting.barPercentage < 100 || this.props.pendingValidationComments } 
                                  onClick={()=>this.setState({isChallengeRejectionModalOpen: true})}
                                >
                                  Submit to Another Vaildator
                                </Button>
                              </Grid>
                            )
                          }
                          <Grid item>
                            <Button
                              color="primary"
                              variant="contained"
                              className={classes.btnFill}
                              disabled={progressBarSetting.barPercentage < 100 || this.props.pendingValidationComments } 
                              onClick={() => {
                                this._publishButtonOnClick(progressBarSetting);
                              }}
                            >
                              Resubmit to Same Vaildator
                            </Button>
                          </Grid>
                        </>
                      )
                    }

                    <MyPATDialog
                      dialogOpen= {isChallengeRejectionModalOpen}
                      otherDialogProps={{
                        fullWidth: true,
                        maxWidth: 'sm',
                      }}
                    >
                      <Grid>
                        <div className={classes.rejectionModal}>
                          <img src="/assets/svg/contentValidation/challenge-rejection-icon.svg" alt="Challenge Rejection" />
                          <h2>Challenge Rejection</h2>
                          <p>Do you really want to challenge the feedback by sending it to another validator? Only feedback with the challenged status will be sent for the final decision.</p>
                          <div className={classes.rejectionModalFooter}>
                            <Button className='modalBtnText' color="primary" onClick={()=>this.setState({isChallengeRejectionModalOpen: false})}>No</Button>
                            <Button className='modalBtnFill' color="primary" onClick={()=>this.submitToAnotherValidator(progressBarSetting)}>Yes</Button>
                          </div>
                        </div>
                      </Grid>
                    </MyPATDialog>
                  </>
                  }
            </Grid>
            <PublishContentDirecltyModal isModalOpen={isPublishDirectlyModalOpen} onModalClose={this.onPublishDirecltyModalClose.bind(this)} onDeclarationAccept={this.onPublishDirectlyClick.bind(this, progressBarSetting)}/>
          </>
          /* // </MyPATCollapse> */
        );
    }

}
const mapStateToProps = (state: any) => {
    return {
        focusedSection: state.commonData.focusedSection,
        validations: state.questionCreate.validations,
        title: state.questionCreate.title,
        optionsContent: state.questionCreate.optionsContent,
        matrixOptionContent: state.questionCreate.matrixOptionContent,
        correctAnswer: state.questionCreate.correctAnswer,
        customAnswer: state.questionCreate.customAnswer,
        solutionContent: state.questionCreate.solutionContent,
        stepWiseSolution: state.questionCreate.stepWiseSolution,
        questionHints: state.questionCreate.questionHints,
        subjects: state.questionCreate.subjects,
        difficultyLevel: state.questionCreate.difficultyLevel,
        difficultyType: state.questionCreate.difficultyType,
        relevantExams: state.questionCreate.relevantExams,
        tags: state.questionCreate.tags,
        draftId: state.questionCreate.draftId,
        contentSubtype: _.get(state, 'mylibraryData.contentSubtype', {}),
        defaultCorrectAnswer: state.questionCreate.defaultCorrectAnswer,
        alternateAnswer: state.questionCreate.alternateAnswer,
        isValidAttempts: state.questionCreate.isValidAttempts,
        allQuestionBenchmarks: state.questionCreate.questionBenchmarks,
        idealTime: _.get(state, "questionCreate.idealTime", {}),
        authenticatedUser:
            state.loginData.userData &&
            state.loginData.userData.authenticatedUser,
        accordianTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianTouched', []),
        accordianCreateTouched: _.get(state, 'contentRequestData.contentRequestAccordianData.accordianCreateTouched', []),
        contentRequestItemsIdForFirstTime: _.get(state, 'contentRequestData.contentRequestAccordianData.contentRequestItemsIdForFirstTime', ''),
        secondarySubjects: state.questionCreate.secondarySubjects,
        questionPreviousExams:_.get(state,"questionCreate.questionPreviousExams",{}),
        concepts: state.conceptAddReducer.concepts,
        finalQuestionBenchmarksPayload: state.questionCreate.finalQuestionBenchmarksPayload,
        syllabusExams: state.questionCreate.syllabusExams,
        remedialQuestionIds:  state.questionCreate.remedialQuestionIds
    }
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    updateQuestionBenchmarks: contentActions.updateQuestionBenchmarks,
    setIsComingFrom: contentRequestAccordianActions.setIsComingFrom,
    setAccordingTouchIndex: contentRequestAccordianActions.setAccordingTouchIndex,
    setIsTabOpened: contentRequestAccordianActions.setIsTabOpened,
    setAccordianTouchWhileCreate: contentRequestAccordianActions.setAccordianTouchWhileCreate,
    setProgressBarForQuestion: contentRequestAccordianActions.setProgressBarForQuestion,
    setAccordianState: contentRequestAccordianActions.setAccordianState,
    setFilterQuestionArray: contentRequestAccordianActions.setFilterQuestionArray,
    setContentRequestItemsIdForFirstTime: contentRequestAccordianActions.setContentRequestItemsIdForFirstTime,
    setRemoveUnresolvedFeedbackCount: contentRequestAccordianActions.setRemoveUnresolvedFeedbackCount,
    setPreviousExams:questionActions.setPreviousExam,
    showMsg: showAlert,
  }, dispatch);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SectionsInContentQuestion));
